import Modal from "react-modal";
import deleteicon from "assets/img/deleteicon.png";
import Form from "./Form";

Modal.setAppElement("#root"); // Required for accessibility

const Popup = ({ trigger, setTrigger }) => {
  return (
    <Modal
      isOpen={trigger}
      onRequestClose={() => setTrigger(false)}
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.1)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 999,
        },
        content: {
          position: "relative",
          inset: "unset",
          padding: "20px",
          background: "white",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
          width: "90%",
          maxWidth: "550px",
          margin: "auto",
        },
      }}
    >
      <button
        className="absolute top-4 right-0 left-4 xl:mr-4"
        onClick={() => setTrigger(false)}
        aria-label="Close"
      >
        <img src={deleteicon} alt="Close" className="w-6 h-6" />
      </button>
      
      <Form />
    </Modal>
  );
};

export default Popup;
